import { Link } from "@components/Link/Link";
import React from "react";
import { withArticleFooter } from "./withArticleFooter";
import Share from "../Share/Share";
import tw from "twin.macro";

const Container = tw.aside`
  w-full bg-transparent
`;
const ShareWrapper = tw.div`
  flex md:hidden justify-center pb-midi
`;
const Wrapper = tw.div`
  max-w-2xl mx-auto px-midi pt-maxi pb-mega flex flex-row justify-between border-t border-tertiary sm:px-maxi md:pt-mega md:pb-tera xl:px-tera
`;
const Previous = tw.div`
  flex flex-col text-body leading-caption w-1/2 items-start text-left pr-midi md:w-full
`;
const Desktop = tw.div`
  hidden md:block
`;
const Next = tw.div`
  flex flex-col text-body leading-caption w-1/2 items-end text-right pl-midi md:w-full 
`;

const ArticleFooter = withArticleFooter(
  ({ previous, next, shareImage, routes, hasMounted, handleClick }) => {
    return (
      <Container>
        <ShareWrapper>
          {hasMounted ? (
            <Share link={window.location.href} image={shareImage} />
          ) : null}
        </ShareWrapper>
        <Wrapper>
          <Previous>
            {previous ? (
              <>
                <span>Previous Article</span>
                <Link
                  className="underline"
                  to={`${routes["ARTICLES"]}/${previous?.slug?.current}`}
                  onClick={handleClick(
                    "Article",
                    `${routes["ARTICLES"]}/${previous?.slug?.current}`,
                  )}
                >
                  {previous?.title}
                </Link>
              </>
            ) : null}
          </Previous>
          <Desktop>
            {hasMounted ? (
              <Share link={window.location.href} image={shareImage} />
            ) : null}
          </Desktop>
          <Next>
            {next ? (
              <>
                <span>Next Article</span>
                <Link
                  className="underline"
                  to={`${routes["ARTICLES"]}/${next?.slug?.current}`}
                  onClick={handleClick(
                    "Article",
                    `${routes["ARTICLES"]}/${next?.slug?.current}`,
                  )}
                >
                  {next?.title}
                </Link>
              </>
            ) : null}
          </Next>
        </Wrapper>
      </Container>
    );
  },
);

export default ArticleFooter;
